import PageTitle from "../../components/title/pageTitle";
import Navigation from "../../components/navigation/navigation";
import IndexImageContainer from "../../components/index-image-container/index-image-container";
import IndexImage from "../../components/index-image/index-image";
import Footer from "../../components/footer/footer";
import {HomePictures} from "../../data/home/home";
import {useEffect} from "react";
import ReactGA from "react-ga4";
import { useTranslation } from "../../i18n";

function Index() {
    const { t } = useTranslation();
    const homePicArray = HomePictures.map((item, i) => (
        <IndexImage
            key={i}
            src={item.src}
            name={t(item.nameKey)}
            link={item.link}
            priority={i < 3}
        />
    ));
    useEffect(() => {
        ReactGA.send({ hitType: "index", page: window.location.pathname });
    }, []);

    return (<>
        <PageTitle>
            <Navigation></Navigation>
        </PageTitle>

        <IndexImageContainer>
            {homePicArray}
        </IndexImageContainer>

        <Footer></Footer>
    </>);
}

export default Index
